export const alertToastConfig: any = {
  toast: true,
  position: "bottom",
  showConfirmButton: false,
  timer: 3000,
};
